import { EditableProps } from "@builder/components/editable/editableProps";
import SidebarCollapse from "@builder/components/app/SidebarCollapse";
import Borders from "@builder/components/editable/style/Borders";
import Background from "@builder/components/editable/style/Background";
import Spacing from "@builder/components/editable/style/Spacing";
import Typography from "@builder/components/editable/style/Typography";

const Variant = ({ parent, stateMode }: EditableProps) => {
    return (
        <SidebarCollapse title="Variant" parent={parent}>
            <Background path={["inputStyles"]} stateMode={stateMode} noWrapper />
            <Borders path={["inputStyles"]} stateMode={stateMode} noWrapper />
            <Spacing path={["inputStyles"]} stateMode={stateMode} excluded={["margin"]} noWrapper />
            <Typography path={["inputStyles"]} stateMode={stateMode} excluded={["margin"]} noWrapper />
        </SidebarCollapse>
    );
};

export default Variant;
